import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { Component } from '@theme/component';

/**
 * Displays the product title with an Orchard variant suffix (e.g. "iPhone 15 - 128GB - Black").
 * Server-renders the suffix when the URL has ?variant=; on in-page variant changes, re-renders
 * the h1 text from the HTML that variant-picker.js fetched.
 *
 * @extends {Component}
 */
class OrchardProductTitle extends Component {
  connectedCallback() {
    super.connectedCallback();
    const section = this.closest('.shopify-section, dialog');
    if (!section) return;
    section.addEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const section = this.closest('.shopify-section, dialog');
    if (!section) return;
    section.removeEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
  }

  /** @param {VariantUpdateEvent} event */
  #onVariantUpdate = (event) => {
    const newTitleEl = event.detail.data.html.querySelector('orchard-product-title h1');
    const currentTitleEl = this.querySelector('h1');
    if (!newTitleEl || !currentTitleEl) return;
    currentTitleEl.textContent = newTitleEl.textContent;
  };
}

if (!customElements.get('orchard-product-title')) {
  customElements.define('orchard-product-title', OrchardProductTitle);
}
